export const isConsentDisabled = process.env.CONSENT_DISABLED === 'true';
